module.exports = __webpack_public_path__ + "img/masterreno2.7df6d765.svg";